import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'

export const useInvalidateDaybookTransaction = () => {
  const queryClient = useQueryClient()

  const invalidateDaybookTransaction = useCallback(
    async (daybookTransactionId?: string) => {
      await queryClient.invalidateQueries([QueryKeys.DaybookTransaction, daybookTransactionId])
    },
    [queryClient],
  )

  return { invalidateDaybookTransaction }
}
